import React from "react";
import styles from "../styles/Operating.module.css";
import organisation from "../img/Organisation.svg";
import partnership from "../img/Partnership.svg";
import Influence from "../img/Influence.svg";
import define from "../img/define.svg";
import nonprop from "../img/Non-prop.svg";
import comm from "../img/comm.svg";

const Operating = () => {
  return (
    <div id="operating" className={styles.operating_cont}>
      <h2>Operating Model</h2>
      <h3>Insurance Advisory Services</h3>
      <p>
        Our operating model is designed to provide maximum value while
        respecting client autonomy <br /> and decision-making authority
      </p>
      <div className={styles.operating_grid}>
        <div className={styles.operating_grid1}>
          <div className={styles.operating_img}>
            <img src={organisation} alt="org" />
          </div>
          <h2>Organizational Involvement</h2>
          <h3>
            Company deals with an Organization, that provides combined / pooled
            expertise
          </h3>
          <p>
            Versus individual consultants - benefit from collective knowledge
            and diverse skill sets
          </p>
        </div>
        <div className={styles.operating_grid1}>
          <div className={styles.operating_img}>
            <img src={partnership} alt="partner" />
          </div>
          <h2>Partnership Oriented</h2>
          <h3>
            Resources can be insourced or provided by Relico, subject to
            acceptance and approval of the Company
          </h3>
          <p>
            Flexible resource deployment aligned with client preferences and
            requirements
          </p>
        </div>
        <div className={styles.operating_grid1}>
          <div className={styles.operating_img}>
            <img src={Influence} alt="influence" />
          </div>
          <h2>Influence Oriented</h2>
          <h3>Final decisions to be taken by the company</h3>
          <p>
            We advise and guide, ensuring decision-making authority remains with
            client leadership
          </p>
        </div>
        <div className={styles.operating_grid1}>
          <div className={styles.operating_img}>
            <img src={define} alt="define" />
          </div>
          <h2>Defined Legitimacy</h2>
          <h3>
            "Legitimacy" for execution to be defined as per pre-agreed roles and
            responsibilities
          </h3>
          <p>Clear governance framework established through mutual agreement</p>
        </div>
        <div className={styles.operating_grid1}>
          <div className={styles.operating_img}>
            <img src={nonprop} alt="nonprop" />
          </div>
          <h2>Non-Prescriptive Approach</h2>
          <h3>Only Execution focused</h3>
          <p>
            Collaborative implementation rather than rigid prescription -
            adaptive to client context
          </p>
        </div>
        <div className={styles.operating_grid2}>
          <div className={styles.operating_img2}>
            <img src={comm} alt="comm" />
          </div>
          <h2>Our Commitment</h2>
          <ul>
            <li>Organizational expertise delivery</li>
            <li>Flexible partnership approach</li>
            <li>Client-led decision making</li>
            <li>Clear role definitions</li>
            <li>Execution-focused delivery</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Operating;
